import { ComponentProps, FC, ReactElement } from 'react';
import { useApiQuery } from '../query/hooks';
import { LoadableSelect } from '../form/LoadableSelect';
import { MenuItem, Select } from '@mui/material';
import { graphql } from '../gql';

const listPhaseQuery = graphql(`
	query phaseSelect_listPhase($journeyId: UUID!) {
		listPhase(filter: { journey: { id: { eq: $journeyId } } }, orderBy: { order: asc }) {
			id
			name
		}
	}
`);

type Props = ComponentProps<typeof Select<string>> &
	Readonly<{
		journeyId?: string;
		loading?: boolean;
		prependItems?: ReactElement;
	}>;

const PhaseSelect: FC<Props> = ({ journeyId, value, loading, disabled, prependItems, ...props }) => {
	const { isLoading: isQueryLoading, data } = useApiQuery(listPhaseQuery, {
		enabled: journeyId != null,
		variables: { journeyId: journeyId ?? '' },
	});

	return (
		<LoadableSelect
			{...props}
			disabled={disabled || journeyId == null}
			loading={loading || (journeyId != null && isQueryLoading)}
			value={value || '' /* value cannot be undefined in order to keep the input controlled */}
		>
			{prependItems}

			{data?.listPhase.map((phase) => (
				<MenuItem key={phase.id} value={phase.id}>
					{phase.name}
				</MenuItem>
			))}
		</LoadableSelect>
	);
};

export { PhaseSelect };
